import React from "react";
import {connect} from "react-redux";
import MyTheme from "../../Theme/Theme";
import {View, Dimensions, Animated, TouchableOpacity, Keyboard, Text} from "react-native";
import Tabs from "../Menu/Tabs";
import {getLastContent,getMyFocus,getContacts,getThemes} from "../../API/api-static";
import TendanceList from "../Tendance/TendanceList";
import FiltrePicto from "../Picto/FiltrePicto";
import ExplorerContactList from "../Explorer/ExplorerContactList";
import ExplorerEntityList from "../Explorer/ExplorerEntityList";
import ExplorerThemeList from "../Explorer/ExplorerThemeList";
import ExplorerContenueList from "../Explorer/ExplorerContenueList";
import {getAllContact, getAllEntity, getAllTheme, getFeedNormal, getBookmark, searchPost} from "../../API/API";
import AvatarIcon from "../Header/AvatarIcon";
import {withTranslation} from "react-i18next";
import {compose} from "redux";


class ExplorerScreen extends React.Component{

    constructor(props) {
        super(props);

        const feeds = {contact: [], entity: [], theme: [], post: []};

        const tabs = [
          {key: 'contact', title: "Contacts"},
          {key: 'entity', title: "Entités"},
          {key: 'theme', title: "Thèmes"},
          {key: 'post', title: "Contenus"},
        ].map(x => ({...x, ref: React.createRef()}))

        this.state = {
          scrollX: new Animated.Value(0),
          activeTab : 0,
          feeds: feeds,
          tabs: tabs,
          postCursor: "",
          bookmark:[],
          search:"",
          themeToDisplay :[]
        }

        this.searchContenu = this.searchContenu.bind(this);
        this._getContenu = this._getContenu.bind(this);

        this.setActiveTab = this.setActiveTab.bind(this);
        this.getActiveTab = this.getActiveTab.bind(this);

        this.navigateToEntityScreen = this.navigateToEntityScreen.bind(this);
        this.mref = React.createRef();
    }

    navigateToEntityScreen(item){
        this.props.navigation.navigate("EntityScreen",{id:item.id,type: "theme"});
    }

    getDimensions() {
      return Dimensions.get('window');
    }

    onItemPress = (itemIndex) => {
        const { width } = this.getDimensions();

        this.mref.current.scrollToOffset({
            offset : itemIndex * width
        });
        Keyboard.dismiss();
    }

    setActiveTab(){
        this.setState({ activeTab : this.getActiveTab() });
    }

    getActiveTab() {
      const { width } = this.getDimensions();
      // width/this.state.scrollX || 0,
      let activeTab = Math.round(this.state.scrollX._value/width);
      return activeTab;
    }

    _deconnexion(){
        const action = {'type': 'SIGN_OUT', 'value': ""};
        this.props.dispatch(action);
    }

    getBookmark(){
        getBookmark().then(data => {
            this.setState({ bookmark: data })
        });
    }

    _getContact(){
        getAllContact().then(data => {
            // if (data === "Not Acceptable") { this._deconnexion(); return }

            this.setState(s => ({feeds: {...s.feeds, contact: data.data}}))
        });
    }

    _getEntity(){
        getAllEntity().then(data=>{
            this.setState(s => ({feeds: {...s.feeds, entity: data.data}}))
        });
    }

    _getTheme(){
       getAllTheme().then(data=>{
            this.setState(s => ({feeds: {...s.feeds, theme: data}}))
        });
    }

    // set search
    searchContenu(search){
      this.setState({ search })
      this.searchPost(search, true);
    }

    // load more
    _getContenu(){
      this.searchPost(this.state.search, false);
    }

    searchPost(search, reload){
        const cursor = reload ? "" : this.state.cursorSearch;

        if (cursor === false) { return; }

        const update = (data) => {
          if (data === "Not Acceptable") { this._deconnexion(); return }


          this.setState(s => {
            const feed = reload ? [] : s.feeds.post;

            return {
              feeds: {...s.feeds, post: feed.concat(data.data) },
              cursorSearch : data.cursor,
            }
          })
        }

        if (search === "") {
          getFeedNormal(cursor).then(update);
        } else {
          searchPost(cursor, search).then(update);
        }
    }

    _setHeader(){
        this.props.navigation.setOptions({
            headerTitle: this.props.t("Explorer"),
            headerTitleAlign: "center",
            headerTitleStyle:{fontFamily: this.props.theme.fonts.title},
            headerLeft: () =>
                <TouchableOpacity
                    onPress={()=>{this.props.navigation.navigate('MyProfil',{})} }>
                    <AvatarIcon style={{width:38,height:38,borderWidth:0,borderRadius:13}}  isHeader={true} icon={this.props.auth.compte.img}/>
                </TouchableOpacity>
        });
    }

    componentDidMount() {
        // load data
        this.getBookmark();
        this._getContact();
        this._getEntity();
        this._getTheme();
        this._getContenu();

        this.setState({ activeTab : this.getActiveTab() });
        this._setHeader();
    }


    renderItem({ item }) {
      switch (item.key) {
          case "contact":
              return <ExplorerContactList type={"contact"} refNavigation={this.props.navigation} isExplorer={true} isFocus={false} isEntity={false} data={item.feed} />;
          case 'entity':
              return <ExplorerContactList type={'entity'} refNavigation={this.props.navigation} isExplorer={true} isFocus={false} isEntity={true} data={item.feed} />;
          case "theme":
              return <ExplorerThemeList type={"theme"} navigateToEntityScreen={this.navigateToEntityScreen} isExplorer={true} focusList={this.state.themeToDisplay}
                      isFocus={false} isEntity={true} data={item.feed}/>;
          case "post":
              return <ExplorerContenueList setSearch={this.searchContenu} bookmark={this.state.bookmark} loadMore={this._getContenu} refNavigation={this.props.navigation}
                      isExplorer={true} isFocus={false} data={item.feed} />;
          default:
              return null;
      }
    }

    render() {
        const { width, height } = this.getDimensions();

        const items = ["contact", "entity", "theme", "post"].map(k => {
          return {key: k, feed: this.state.feeds[k]};
        })

        // <UserInactivity timeForInactivity={90000} onAction={() => {const action = {'type': 'SIGN_OUT_NIP', 'value':{}};this.props.dispatch(action);}} >
        return (<View style={{flex:1,flexDirection:"column",width:width,height:height}}>

                <Tabs style={{top:10}} scrollX={this.state.scrollX} total_width={width}
                      data={this.state.tabs} indexActive={this.state.activeTab}
                      onItemPressCallBack={this.setActiveTab} onItemPress={this.onItemPress}/>

                <Animated.FlatList
                    style={{marginTop:60,flex:1,overflowX:"scroll"}}
                    ref={this.mref}
                    data={items}
                    horizontal={true}
                    showsHorizontalScrollIndicator={false}
                    pagingEnabled={true}
                    bounces={false}
                    onScroll={Animated.event([{nativeEvent :{contentOffset:{x:this.state.scrollX}}}],{listener :(event)=>{this.setActiveTab()} ,useNativeDriver:false})}
                    renderItem={this.renderItem.bind(this)}
                />

            </View>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(connect(mapStateToProps),withTranslation())(ExplorerScreen);
